import { setUnavailable } from '../../taskrouter';
import { ROUTES } from '../../../Constants';

export function gotoDashboard(history) {
  return async () => {
    history.push(ROUTES.LOADING);

    try {
      await setUnavailable();
      history.push(ROUTES.HOME);
    } catch (err) {
      history.goBack();
    }
  };
}
